<template>
  <div class="dashboard_container db_observer">

    <div class="row">
	    <div class="col-12 dashboard-content-section">
	        <div class="col-6 pr-1 float-left">
	            <b-col cols="12 pl-0 pr-0 pg-lft-col">
	                <b-row class="dashboard-row">
	                    <b-col cols="12">
	                        <div class="card">
	                            <div class="card-header">
	                                <span class="icon float-left icon-course text-center mr-2"></span>
	                                <span class="label" role="heading" aria-lavel="1" tabindex="0">All Courses</span>
	                            </div>
	                            <div class="card-body carousel slide">
	                                <div class="carousel-inner">
	                                    <button class="button-primary fa fa-angle-left float-left" :disabled="page === 0" @click="prev" aria-label="previous"></button>
	                                    <div class="item active">
	                                        <template v-for="course in courses">
	                                            <div class="course" @click="navigateToCourseDashboard(course.uuid)" :title="course.title" tabindex="0">
	                                                <div class="course_name" :title="course.title" :aria-label="course.title">{{course.title}}</div>
	                                                <div class="thumbnail_container">
	                                                    <div class="icon-course">
	                                                  		<div class="icon-master" v-if="course.master">m</div>
	                                                    </div>
	                                                </div>
	                                            </div>
	                                        </template>
	                                    </div>
	                                    <button class="button-primary fa fa-angle-right float-right" :disabled="lastPage === true" @click="next" aria-label="next"></button>
	                                </div>
	                            </div>
	                        </div>
	                    </b-col>
	                </b-row>

	                <b-row class="dashboard-row btm-sec">
	                    <b-col cols="12">
	                        <div class="card">
	                            <div class="card-header">
	                                <span class="icon float-left icon-link text-center mr-2"></span>
	                                <span class="label" role="heading" aria-lavel="1" tabindex="0">Quick Links</span>
	                            </div>
	                            <div class="card-body">
	                                <div class="card-content v_scroll">
	                                    <div class="quick_link">
	                                        <b-nav v-for="quickLink in quickLinks">
	                                            <a :href="quickLink.url" target="_blank" :aria-label="quickLink.title">{{quickLink.title}}</a>
	                                        </b-nav>
	                                    </div>
	                                </div>
	                            </div>
	                        </div>
	                    </b-col>
	                </b-row>
	            </b-col>
	        </div>

	        <div class="col-6 pl-1 float-right">
	            <b-col cols="12" class="pr-0 pg-rgt-col">
	                <b-row class="dashboard-row">
	                    <b-col cols="12 pr-0">
	                        <div class="card">
	                            <div class="card-header">
	                                <span class="icon float-left icon-bullhorn text-center mr-2"></span>
	                                <span class="label" role="heading" aria-lavel="1" tabindex="0">Recommendations</span>
	                            </div>
	                            <div class="card-body">
	                                <div class="card-content v_scroll">

	                                    <div class="recommendations">

	                                        <div class="coming_soon">Coming Soon</div>

	                                        <!--
	                                        <div class="row">
	                                            <div class="profile_pic">
	                                                <span class="icon icon-admin"></span>
	                                            </div>
	                                            <div class="details">
	                                                <div class="tp_row">
	                                                    <div class="title">Administrator</div>
	                                                    <div class="time">7:23 PM</div>
	                                                </div>
	                                                <div class="btm_row">
	                                                    Internship at Qualcom
	                                                </div>
	                                            </div>
	                                        </div>

	                                        <div class="row">
	                                            <div class="profile_pic">
	                                                <span class="icon icon-user"></span>
	                                            </div>
	                                            <div class="details">
	                                                <div class="tp_row">
	                                                    <div class="title">Prof. Whitman</div>
	                                                    <div class="time">7:43 PM</div>
	                                                </div>
	                                                <div class="btm_row">
	                                                    Internship at Illumina. There is only one space left.
	                                                </div>
	                                            </div>
	                                        </div>

	                                        <div class="row">
	                                            <div class="profile_pic">
	                                                <span class="icon icon-user"></span>
	                                            </div>
	                                            <div class="details">
	                                                <div class="tp_row">
	                                                    <div class="title">Prof. Kandinsky</div>
	                                                    <div class="time">6:18 PM</div>
	                                                </div>
	                                                <div class="btm_row">
	                                                    Veterna’s Center talk
	                                                </div>
	                                            </div>
	                                        </div>
	                                        -->
	                                        <!-- row end -->

	                                    </div> <!-- recommendations end -->

	                                </div> <!-- card-content end -->
	                            </div> <!-- card-body end -->
	                        </div> <!-- card end -->
	                    </b-col>
	                </b-row> <!-- dashboard-row end -->
	            </b-col>
	        </div>
	    </div>
    </div>

	</div>
</template>

<script>
  import '../../../assets/module/css/dashboard/dashboard.min.css'
  import { mapState, mapActions } from 'vuex'

  var staticQuickLinks = function () {
    var quickLinks = []
    return quickLinks
  }

  export default {
    name: 'observer-dashboard',
    props: [],
    data: () => {
      return {
        page: 0,
        courses: [],
        lastPage: false,
        quickLinks: []
      }
    },

    ready: function () {
      window.addEventListener('resize', this.populateEnrolledCourses())
    },

    mounted () {
      this.loadQuickLinks().then(res => {
        const quickLinks = (this.links.length > 0) ? this.links : staticQuickLinks()
        $.each(quickLinks, (index, quickLink) => {
          this.quickLinks.push(quickLink)
        })
      })
      this.populateEnrolledCourses()
      window.addEventListener('resize', this.handleWindowResize)
    },

    methods: {
      ...mapActions([
        'loadQuickLinks',
        'loadEnrolledCourses'
      ]),

      handleWindowResize (event) {
        let routeName = this.$router.currentRoute.name
        if (routeName === 'observerDashboard') {
          this.populateEnrolledCourses()
        }
      },

      populateEnrolledCourses () {
        var itemCount
        if ($(window).width() < 1501) {
          itemCount = 2
        } else {
          itemCount = 3
        }
        const pagingOptions = {page: this.page, count: itemCount}
        this.loadEnrolledCourses(pagingOptions).then(res => {
          if (res && res.length > 0) {
            this.courses = res
            if (res.length < this.count) {
              this.lastPage = true
            }
          } else {
            if (this.page > 0) {
              this.page -= 1
            }
            this.lastPage = true
          }
        })
      },

      prev () {
        if (this.page > 0) {
          this.page -= 1
          this.populateEnrolledCourses()
        }

        if (this.lastPage) {
          this.lastPage = false
        }
      },

      next () {
        if (!this.lastPage) {
          this.page += 1
          this.populateEnrolledCourses()
        }
      },

      navigateToCourseDashboard (uuid) {
        this.$store.commit('LOAD_COURSE', {})
        this.$store.commit('LOAD_CLASS_SUMMARY', {})
        this.$store.commit('LOAD_COURSE_TOPICS', {})
        this.$store.commit('LOAD_COURSE_LINEAR_TOPICS', {})
        return this.$router.push({name: 'courseDashboardInstructor', params: { uuid: uuid }})
      }
    },

    computed: {
      ...mapState({
        'links': state => state.dashboard.quickLinks
      })
    }
  }
</script>

<style scoped>
    .next {
        margin-top: 10%;
    }

    .icon-master {
        float: right !important;
        margin-top: 0px !important;
        margin-left: 0px !important;
    }

    .slide-leave-active, .slide-enter-active {
        transition: 1s;
    }

    .slide-enter {
        transform: translate(100%, 0);
    }

    .slide-leave-to {
        transform: translate(-100%, 0);
    }

    .img-slider {
        overflow: hidden;
        position: relative;
        height: 200px;
        width: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/ObserverDashboard.vue